/* Theme-only, reversible referral-page hiding. No customer/app data changes. */
(function () {
  'use strict';
  var selector = 'a[href*="/pages/referral-program"]';

  function hideLink(link) {
    var url;
    try { url = new URL(link.getAttribute('href'), window.location.href); }
    catch (error) { return; }
    if (!/\/pages\/referral-program\/?$/.test(url.pathname)) return;
    link.hidden = true;
    // App-generated sitemap: also hide the containing bullet, but never a
    // navigation group containing other links/content.
    var item = link.closest('li');
    if (item && item.querySelectorAll('a').length === 1 &&
        item.textContent.trim() === link.textContent.trim()) item.hidden = true;
  }

  function hideWithin(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(selector)) hideLink(root);
    root.querySelectorAll(selector).forEach(hideLink);
  }

  hideWithin(document);
  // Only added subtrees are inspected, not the entire document per mutation.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(hideWithin);
    });
  }).observe(document.body, {childList: true, subtree: true});

  if (/\/pages\/referral-program\/?$/.test(window.location.pathname)) {
    document.title = 'Referral program temporarily unavailable | Flores Flowers';
  }
})();
